<template>
  <div>
    <v-menu bottom offset-y transition="scale-transition">
      <template v-slot:activator="{ on }">
        <span v-on="on">
          <mf-button id="save-template" data-userflow-id="save-template" text label="Salvar como template" />
        </span>
      </template>
      <v-list>
        <v-list-item @click="isNewTemplateOpen = true">
          <v-list-item-title>Criar novo template</v-list-item-title>
        </v-list-item>
        <v-list-item @click="isOverwriteTemplateOpen = true">
          <v-list-item-title>Sobrescrever template existente</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <new-builder-template v-model="isNewTemplateOpen" :template-getter="templateGetter" />
    <overwrite-builder-template v-model="isOverwriteTemplateOpen" :template-getter="templateGetter" />
  </div>
</template>

<script>
export default {
  components: {
    NewBuilderTemplate: () => import('@/modules/campanhas/campanhas-email/views/components/builder-templates/NewBuilderTemplate.vue'),
    OverwriteBuilderTemplate: () => import('@/modules/campanhas/campanhas-email/views/components/builder-templates/OverwriteBuilderTemplate.vue'),
  },
  props: {
    templateGetter: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    isNewTemplateOpen: false,
    isOverwriteTemplateOpen: false,
  }),
}
</script>
